import {chainWalk, getDateInMMDDYYYYWithOffset} from "../Utility";
import {getInductPackageMetrics} from "../resources/InductResource";
import {getStowAssociateMetrics, getStowFloorMetrics, getStowPackageMetrics} from "../resources/StowResource";
import {getPickPackageMetrics} from "../resources/PickResource";
import {AssociateMetric, InductPackageMetric, Resource, StowPackageMetric} from "../enums";
import {TOTAL} from "../constants";

export const LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE = "LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR = "LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR";
export const LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN = "LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN";
export const LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE = "LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE";
export const LOAD_PICK_PACKAGE_METRICS_FOR_NODE = "LOAD_PICK_PACKAGE_METRICS_FOR_NODE";
export const LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR = "LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE = "LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR = "LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR";
export const LOAD_STOW_FLOOR_METRICS_FOR_NODE = "LOAD_STOW_FLOOR_METRICS_FOR_NODE";
export const LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR = "LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR";
export const LOAD_STOW_PACKAGE_METRICS_FOR_NODE = "LOAD_STOW_PACKAGE_METRICS_FOR_NODE";
export const LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR = "LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR";

const loadInductPackageMetricsForNode = (totalInductPackageMetrics) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,
    totalInductPackageMetrics
});

const loadInductPackageMetricsForStationPair = (inductPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR,
    inductPackageMetricsMap
});

const loadMetricsForStationPairCallBegin = () => ({
    type: LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN
});

const loadMetricsForStationPairCallFailure = () => ({
    type: LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE
});

const loadPickPackageMetricsForNode = (totalPickPackageMetricsMap) => ({
    type: LOAD_PICK_PACKAGE_METRICS_FOR_NODE,
    totalPickPackageMetricsMap
});

const loadPickPackageMetricsForStationPair = (pickPackageMetricsMap) => ({
    type: LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR,
    pickPackageMetricsMap
});

const loadStowAssociateMetricsForNode = (totalStowAssociateMetrics) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,
    totalStowAssociateMetrics
});

const loadStowAssociateMetricsForStationPair = (stowAssociateMetricsMap) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR,
    stowAssociateMetricsMap
});

const loadStowFloorMetricsForNode = (totalStowFloorMetricsMap) => ({
    type: LOAD_STOW_FLOOR_METRICS_FOR_NODE,
    totalStowFloorMetricsMap
});

const loadStowFloorMetricsForStationPair = (stowFloorMetricsGroupMap) => ({
    type: LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR,
    stowFloorMetricsGroupMap
});

const loadStowPackageMetricsForNode = (totalStowPackageMetrics) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_NODE,
    totalStowPackageMetrics
});

const loadStowPackageMetricsForStationPair = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR,
    stowPackageMetricsMap
});

export const getInductPackageMetricsForStationPair = (nodeId) => {
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForStationPairCallBegin());
            const request = constructInductPackageMetricsForStationPairRequest(nodeId);
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            if (inductPackageMetricsMap) {
                dispatch(loadInductPackageMetricsForNode(getTotalMetrics(inductPackageMetricsMap)));
                dispatch(loadInductPackageMetricsForStationPair(inductPackageMetricsMap));
            } else {
                dispatch(loadMetricsForStationPairCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForStationPairCallFailure());
        }
    }
}

export const getPickPackageMetricsForStationPair = (nodeId) => {
    return async (dispatch) => {
        dispatch(loadMetricsForStationPairCallBegin());
        try {
            const request = constructPickPackageMetricsRequest(nodeId);
            const pickPackageMetricsMap = await getPickPackageMetrics(request);
            if (pickPackageMetricsMap) {
                dispatch(loadPickPackageMetricsForNode(getTotalMetrics(pickPackageMetricsMap)));
                dispatch(loadPickPackageMetricsForStationPair(pickPackageMetricsMap));
            } else {
                dispatch(loadMetricsForStationPairCallBegin());
            }
        } catch (error) {
            dispatch(loadMetricsForStationPairCallBegin());
        }
    }
}

export const getStowAssociateMetricsForStationPair = (nodeId) => {
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForStationPairCallBegin());
            const request = constructStowAssociateMetricsForStationPairRequest(nodeId)
            const stowAssociateMetricsMap = await getStowAssociateMetrics(request)
            if (stowAssociateMetricsMap) {
                dispatch(loadStowAssociateMetricsForNode(getTotalMetrics(stowAssociateMetricsMap)));
                dispatch(loadStowAssociateMetricsForStationPair(stowAssociateMetricsMap));
            } else {
                dispatch(loadMetricsForStationPairCallBegin());
            }
        } catch (error) {
            dispatch(loadMetricsForStationPairCallBegin());
        }
    }
}

export const getStowFloorMetricsForStationPair = (nodeId) => {
    return async (dispatch) => {
        try {
            const request = constructStowFloorMetricsForStationPairRequest(nodeId);
            dispatch(loadMetricsForStationPairCallBegin());
            const stowFloorMetricsGroupMap = await getStowFloorMetrics(request);
            if (stowFloorMetricsGroupMap) {
                dispatch(loadStowFloorMetricsForNode(getTotalFloorMetrics(stowFloorMetricsGroupMap)));
                dispatch(loadStowFloorMetricsForStationPair(stowFloorMetricsGroupMap));
            } else {
                dispatch(loadMetricsForStationPairCallBegin());
            }
        } catch (error) {
            dispatch(loadMetricsForStationPairCallBegin());
        }
    }
}


export const getStowPackageMetricsForStationPair = (nodeId) => {

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForStationPairCallBegin());
            const request = constructStowPackageMetricsForStationPairRequest(nodeId)
            const stowPackageMetricsMap = await getStowPackageMetrics(request)
            if (stowPackageMetricsMap) {
                delete stowPackageMetricsMap[TOTAL]
                dispatch(loadStowPackageMetricsForNode(getTotalMetrics(stowPackageMetricsMap)));
                dispatch(loadStowPackageMetricsForStationPair(stowPackageMetricsMap));
            } else {
                dispatch(loadMetricsForStationPairCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForStationPairCallFailure());
        }
    }
}

function getTotalMetrics(groupedMetricsMap) {
    const totalMetricsMap = {};
    for (const stationPair in groupedMetricsMap) {
        const metricsMap = groupedMetricsMap[stationPair];

        for (const metric in metricsMap) {
            if (!totalMetricsMap[metric]) {
                totalMetricsMap[metric] = metricsMap[metric];
            } else {
                totalMetricsMap[metric] = +totalMetricsMap[metric] + +metricsMap[metric];
            }
        }
    }

    return {Total: totalMetricsMap};
}

function getTotalFloorMetrics(floorMetricsGroupMap) {
    const totalFloorMetrics = {};
    for (const stationPair in floorMetricsGroupMap) {
        const floorMetrics = chainWalk(() => floorMetricsGroupMap[stationPair].floorMetrics, null);
        if (floorMetrics) {
            for (const metric in floorMetrics) {
                if (!totalFloorMetrics[metric]) {
                    totalFloorMetrics[metric] = floorMetrics[metric];
                } else {
                    totalFloorMetrics[metric] = +totalFloorMetrics[metric] + +floorMetrics[metric];
                }
            }
        }
    }
    return {Total: totalFloorMetrics};
}

const constructInductPackageMetricsForStationPairRequest = (nodeId) => {
    return {
        groupBy: "StationPair",
        nodeId: nodeId,
        metricList: [
            InductPackageMetric.INDUCTED,
            InductPackageMetric.CUMULATIVE_INDUCTED
        ]
    }
}

const constructPickPackageMetricsRequest = (nodeId) => {
    return {
        groupBy: Resource.STATION_PAIR,
        stationCode: nodeId,
        metricList: ["PICKED"],
        date: getDateInMMDDYYYYWithOffset(0)
    }
}

const constructStowAssociateMetricsForStationPairRequest = (nodeId) => {
    return {
        groupBy: Resource.STATION_PAIR,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            AssociateMetric.ACTIVE_ASSOCIATE_COUNT,
            AssociateMetric.INACTIVE_ASSOCIATE_COUNT
        ]
    }
}

const constructStowFloorMetricsForStationPairRequest = (nodeId) => {
    return {
        groupBy: Resource.STATION_PAIR,
        filters: {
            NODE: [nodeId]
        },
        metrics: ["FLOORS_COUNT_MISSING_CART"]
    }
}

const constructStowPackageMetricsForStationPairRequest = (nodeId) => {
    return {
        groupBy: Resource.STATION_PAIR,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            StowPackageMetric.STOW_RATE,
            StowPackageMetric.PROBLEM_SOLVE_COUNT,
            StowPackageMetric.STOWED_COUNT
        ]
    }
}



// WEBPACK FOOTER //
// ./src/actions/StationPairActions.js